
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 0H0v40h40V0h-8zM10.7 32.4H8v-2.7h2.7v2.7zM21 10.2H10.7v5.9h9.4v2.2h-9.4v8.2H8V8h13v2.2zm11 22.2h-2.7v-2.7H32v2.7zm0-21.7h-2.7V8H32v2.7z","fill":"#1c1c1b"}})])
          )
        }
      }
    